import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'timer-label',
  template: `<span *ngIf="show" [ngClass]="'label label-' + type">{{text}}</span>`
})
export class TimerLabelComponent implements OnInit {
  @Input() until?: string;
  @Input() type?: string;
  @Input() text?: string;

  show = false;

  private fmt = 'YYYY-MM-DD';

  ngOnInit(): void {
    const today = moment().format(this.fmt);

    this.until = this.until || this.getYesterday();
    this.type = this.type || 'success';
    this.text = this.text || 'New!';
    this.show = this.until > today;
  }

  private getYesterday(): string {
    return moment().subtract(1, 'days').format(this.fmt);
  }
}
